import moment from "moment";
import React from "react";

const TransactionDetails = ({ data }) => {
  return (
    <div className="roles-bg rounded-4 col-md-5 mt-0 pb-4">
      <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
        Transaction Details
      </h2>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Type
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.type}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Payment Mode
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.payment_mode}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Transaction Amount
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.paid_amount}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Payment Method
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.payment_method}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Payment Status
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.payment_status}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Date Time
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {moment(data?.transaction_date).format("DD-MM-YYYY HH:mm a")}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Pay Order Id
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {data?.payment_order_id}
        </p>
      </div>
    </div>
  );
};

export default TransactionDetails;
